const errorComponent = () => {
  localStorage.clear();
  globalThis.location = '/';
  return null;
};
export default errorComponent;
